import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
import { errorParser } from "../utils";

import environment from "../common/environment";

const channel = Radio.channel("global");

class NoteEditor extends Marionette.Behavior {
  ui() {
    return {
      button: "#add-note button",
      note: "#add-note input",
    };
  }

  defaults() {
    return {
      opts: {
        modelProperty: "notes",
        service: null,
        config: null,
      },
    };
  }

  events() {
    return {
      "click @ui.button": "_handleNote",
      "keypress @ui.note": "_handleNote",
    };
  }

  initialize() {
    this.url = null;

    // merge defaults and user options
    _.defaults(this.options.opts, this.defaults.opts);

    if (this.options.opts.service) {
      // get service endpoint
      this.url = environment.getEndpoint(
        this.options.opts.service,
        this.options.opts.config
      );
    } else {
      console.warn(
        "A required service name was not provided for the Note Editor behavior."
      );
    }
  }

  _handleNote(e) {
    switch (e.type) {
      case "keypress":
        // ignore all keys, except for enter
        if (13 === e.which) {
          e.preventDefault();
          // trigger button click
          this.ui.button.click();
        }
        break;

      case "click":
        // grab input value and trim it
        const note = $.trim(this.ui.note.val());

        // update UI with trimmed field value
        this.ui.note.val(note);

        if (_.isEmpty(note)) {
          // show error
          channel.trigger("status:show", {
            type: "warning",
            message: "The note field cannot be empty",
          });
        } else {
          // clear input field
          this.ui.note.val("");

          // create note
          this._createNote(note);
        }

        break;
    }
  }

  _createNote(note) {
    // POST the note
    $.ajax({
      url: this.url,
      method: "POST",
      contentType: "application/json",
      processData: false,
      data: JSON.stringify({ note }),
      success: (data) => {
        // get existing notes from model
        const notesColl = this.view.model.get(this.options.opts.modelProperty);
        // splice new note at the top of the existing notes collection
        notesColl.add(data, { at: 0 });
        // update model with updated collection
        this.view.model.set(this.options.opts.modelProperty, notesColl);
      },
      error: (jqXHR) => {
        // show error
        channel.trigger("status:show", {
          autoDismiss: false,
          type: "danger",
          message: errorParser(jqXHR),
        });
      },
    });
  }
}

export { NoteEditor as default };
